import { ErrorElement } from 'App';
import { Route, Routes } from 'react-router-dom';
import { Integrations } from './Integrations';
import { MoreScopeIntegration } from './MoreScopeIntegration';

export const IntegrationsRoutes = () => {
  return (
    <Routes>
      <Route index element={<Integrations />} errorElement={<ErrorElement />} />
      <Route path="morescope" element={<MoreScopeIntegration />} errorElement={<ErrorElement />} />
    </Routes>
  );
};
